import React from "react";

import AlertCircle from "@uui/AlertCircle";
import CloseIcon from "@uui/XClose";
import { DateTime } from "luxon";

import IconButton from "@mui/material/IconButton";

import { pluralizePhrase } from "@app/common/utils";

import { getFileSizeDisplay } from "@rui/FileUpload/utils";
import { Column, Row } from "@rui/Stack";

import LinearProgressWithLabel from "./LinearProgressWithLabel";
import { EditButton, TitleText, InfoText, DateText } from "./styles";

interface ProgressRow {
  title: string;
  progress: number;
  status: "loading" | "complete" | "error";
  startTime: DateTime | null;
  duration: number | null;
  size: number | null;
  onCancel?: (event: React.MouseEvent) => void;
  onEdit?: (event: React.MouseEvent) => void;
}

const ProgressRow = ({
  title,
  progress,
  status,
  startTime,
  duration,
  size,
  onCancel,
  onEdit,
}: ProgressRow) => {
  const displaySize = getFileSizeDisplay(size);

  return (
    <Column>
      <Row variant="apart" spacing={2}>
        <Column
          spacing="2px"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          <TitleText>{title}</TitleText>
          <InfoText>
            {duration ? pluralizePhrase(Math.ceil(duration), "minute") : null}
            {duration && size ? " • " : null}
            {size && displaySize}
          </InfoText>
        </Column>
        <Row variant="right" spacing={2} flexShrink={0}>
          <DateText startTime={startTime} />
          {onEdit && <EditButton onClick={onEdit}>Edit</EditButton>}
          {onCancel && (
            <IconButton
              sx={{ width: "24px", height: "24px" }}
              onClick={onCancel}
            >
              <CloseIcon sx={{ width: "18px", height: "18px" }} />
            </IconButton>
          )}
        </Row>
      </Row>

      <LinearProgressWithLabel
        status={status}
        value={progress}
        icon={status === "error" ? <AlertCircle /> : undefined}
      />
    </Column>
  );
};

export default ProgressRow;
